import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../components/HeaderRegister";
import { TransporterService } from "../../services/transporter.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { Formik } from "formik";
import * as yup from 'yup';
import { TransporterModel } from "../../models/transporter.model";
import storageService from "../../services/storage.service";

export const TransporterRegister = () => {
  const { id } = useParams<{id?: string}>();
  const [initialValues, setInitialValues] = useState<TransporterModel>({
    id: 0,
    fullName: '',
    document: ''
  });
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const history = useHistory();

  const initialize = async () => {
    if (Number(id)) {
      const response: any = await TransporterService.getById(id);
      if (response.success) {
        setInitialValues(response.result);
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    fullName: yup.string().required(t('REQUIRED')).max(100, t('TRANSPORTER.FULLNAME_MAX_LENGTH')),
    document: yup.string().required(t('REQUIRED')).max(25, t('TRANSPORTER.DOCUMENT_MAX_LENGTH'))
  });

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const user = storageService.getUser();

  const saveTransporter = (transporter: TransporterModel) => {
    setLoading(true);
    if (transporter.id > 0) {
      TransporterService.update(transporter).then((response: any) => {
        if (response.success) {
          ToastService.success(t('TRANSPORTER.UPDATED'));
          history.push('/Transporter');
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      TransporterService.insert(transporter).then((response: any) => {
        if (response.success) {
          ToastService.success(t('TRANSPORTER.INSERTED'));
          history.push('/Transporter');
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  return (
    <>
      <HeaderRegister title={`${t('TRANSPORTER.TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/Transporter"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <Formik
        enableReinitialize={true} 
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          saveTransporter(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='fullName'
                          id='fullName'
                          type='text'
                          placeholder={t('TRANSPORTER.FULLNAME')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.fullName && !!errors.fullName}
                          value={values.fullName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.fullName}
                        </Form.Control.Feedback>
                        <Form.Label>{t('TRANSPORTER.FULLNAME')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='document'
                          id='document'
                          type='text'
                          maxLength={14}
                          placeholder={t('TRANSPORTER.DOCUMENT')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.document && !!errors.document}
                          value={values.document}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.document}
                        </Form.Control.Feedback>
                        <Form.Label>{t('TRANSPORTER.DOCUMENT')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
       )}
      </Formik>
    </>
  );
};
